import React from 'react';
import { translate, Edit, SimpleForm, required, TextInput  } from 'admin-on-rest';

import { SaveButton, Toolbar } from 'admin-on-rest';

const PostCreateToolbar = props => <Toolbar {...props} >
    <SaveButton label='aor.action.save' redirect="/" />
</Toolbar>;

const hintStyle = {
	fontSize: '11px',
	fontStyle: 'italic',	
	color: '#999',	
	display: 'block',
	marginTop: '3px',
	marginBottom: '5px',	
}

export const EditDetails = (props) => (
    <Edit title="Gegevens wijzigen" {...props}>
        <SimpleForm toolbar={<PostCreateToolbar />}>
            <TextInput source="email" type="email" label="E-mail adres" />
            <TextInput source="password" type="password" label="Wachtwoord" />
			
			<span style={hintStyle}>Laat wachtwoord leeg om ongewijzigd te laten</span>
            
			<TextInput source="company_name" label="Bedrijfsnaam" />
            <TextInput source="company_site" type="url" label="Website" />
			
            <TextInput source="address_street" label="Adres - straat" />
            <TextInput source="address_unitnr" label="Adres - huisnummer" />
            <TextInput source="address_zip" label="Adres - postcode" />
            <TextInput source="address_city" label="Adres stad" />
            <TextInput source="company_phone" label="Telefoon" />
			
        </SimpleForm>
    </Edit>
);


// WEBPACK FOOTER //
// ./src/member/Member.js